import { Injectable } from '@angular/core';

import { BaseService } from './base.service';
import { DynamicListFieldRawResponseModel } from '../model/dynamic-list-field-raw-response.model';
import { DynamicListFieldOptionsResponseModel } from '../model/dynamic-list-field-options-response.model';

type FieldType =
DynamicListFieldRawResponseModel |
DynamicListFieldOptionsResponseModel;

@Injectable()
export class DynamicListFieldResponseService {
  pathGrouped = '/dynamic-list-item/grouped';

  pathRaw = '/dynamic-list-field-raw-response/';
  pathOption = '/dynamic-list-field-options-response/';

  constructor(private baseService: BaseService) {}

  getAllRawResponses(query = { init: 0, end: 1e8 }) {
    return this.baseService.get(this.pathRaw, '', query);
  }

  getAllRawResponsesGrouped(query = {}) {
    return this.baseService.get(this.pathGrouped, '', { init: 0, end: 1e8, ...query });
  }

  getAllOptionResponses() {
    return this.baseService.get(this.pathOption, '', { init: 0, end: 1e8 });
  }

  getPaginated(field: FieldType, init: number, end: number) {
    return this.baseService.get(this.getPath(field), '', { init, end });
  }

  postField(field: FieldType) {
    return this.baseService.post(this.getPath(field), '', field);
  }

  putField(field: FieldType) {
    return this.baseService.put(this.getPath(field), '', field);
  }

  deleteField(field: FieldType) {
    return this.baseService.delete(this.getPath(field), field.id + '');
  }

  saveField(field: FieldType) {
    if (field.id) return this.putField(field); else return this.postField(field);
  }

  saveFieldRawResponse(responses: FieldType[]) {
    console.log(responses[0])
    if (responses[0].dyn_list_item_id)
    return this.putFieldRawResponse(responses);
    else return this.postFieldRawResponse(responses);
  }

  postFieldRawResponse(fields: FieldType[]) {
    return this.baseService.post(this.pathRaw, '', fields);
  }

  putFieldRawResponse(fields: FieldType[]) {
    return this.baseService.put(this.pathRaw, '', fields);
  }

  saveFieldOptionResponse(fields: FieldType[]) {
    return this.baseService.post(this.pathOption, '', fields);
  }

  // Aux
  getPath = (field: any) => field.dyn_list_field_option_id ? this.pathOption : this.pathRaw;
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/dynamic-list-response.service.ts